module.exports = __webpack_public_path__ + "img/People-That-Enjoy-Convienences.d2412a97.jpg";